import {store} from '../../App';
import config from '../../config';

let axios = require('axios'),
    io    = require('../io/index').actions;

export const actiontypes = {
  TRACK_GETALL_SUCCESS: 'TRACK_GETALL_SUCCESS',
}
export const actions = {
  getAllTracks: () => {
    return dispatch => {
      dispatch(io.loading());

      axios.get(config.API_ADDRESS+'/tracks/all', {
        headers: {
          'Authorization': `Bearer ${store.getState().session.token}`
        }
      })
      .then(res => res.data)
      .then(json => {
        dispatch(trackGetAllSuccess(json));
        dispatch(io.loading(false));
      })
      .catch(err => dispatch(io.message(err.message, 'error', false)));
    }
  }
}


function trackGetAllSuccess(tracks) {
  return {
    type: actiontypes.TRACK_GETALL_SUCCESS,
    tracks
  }
}



// WEBPACK FOOTER //
// ./src/actions/tracks/get.js